import { createContext, useContext, useEffect, useState } from "react";
import en from "./en";
import fr from "./fr";
import es from "./es";
import ar from "./ar";
import am from "./am";
import ti from "./ti";

const DICTS = { en, fr, es, ar, am, ti };

export const LANGUAGES = [
  { code: "en", native: "English" },
  { code: "am", native: "አማርኛ" },
  { code: "ti", native: "ትግርኛ" },
  { code: "fr", native: "Français" },
  { code: "es", native: "Español" },
  { code: "ar", native: "العربية" },
];

const LanguageContext = createContext(null);

const dig = (dict, path) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("nextg-lang");
    return saved && DICTS[saved] ? saved : "en";
  });

  useEffect(() => {
    localStorage.setItem("nextg-lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.body.classList.toggle("font-ethiopic-body", lang === "am" || lang === "ti");
    document.body.classList.toggle("font-arabic-body", lang === "ar");
  }, [lang]);

  const t = (path, vars) => {
    let v = dig(DICTS[lang], path);
    if (v === undefined) v = dig(en, path);
    if (v === undefined) return path;
    if (vars && typeof v === "string") {
      Object.entries(vars).forEach(([k, val]) => {
        v = v.replaceAll(`{${k}}`, String(val));
      });
    }
    return v;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, rtl: lang === "ar" }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
